<template>
  <div>
    <slot v-bind:selectedColor="selectedColor">
      <pre>
        Use the wf-product-detail-state component to display information about the product detail page's current state.
        Define content in the component's default slot.
      </pre>
    </slot>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      selectedColor: 'productDetail/color'
    })
  },
  created(){
    // window.addEventListener('scroll', this.stickyAsideBar);
    // window.addEventListener("resize", this.stickyAsideBar);
  },
  methods: {
    stickyAsideBar: function(){
      let stickySection = document.getElementById('aside-sticky-section');
      if(!stickySection) return;
      
      let mainTagPosition = document.getElementById('main').getBoundingClientRect();
      
      stickySection.style = '';
      stickySection.classList.remove('pdp-sticky-section');
      let initialWidth = stickySection.clientWidth;

      if(mainTagPosition.top < 0){
        // let editContentAreaPostion = document.querySelector('.page-bottom-editable-area').getBoundingClientRect();
        let footerPosition = document.getElementById('footer').getBoundingClientRect();
        let mainPosition = document.querySelector('#main > .container-fluid').getBoundingClientRect();
        let lastSectionMargin = parseFloat(window.getComputedStyle(document.querySelector('#main .wf-image-cards > section')).marginBottom);
        let stikyPosition = document.getElementById('aside-sticky-section').getBoundingClientRect();
        let leftColumnPosition = document.querySelector('#main .row.align-items-start.no-gutters .col-12.col-lg-8.col-xl-9').getBoundingClientRect();

        if(mainPosition.bottom - lastSectionMargin - stikyPosition.height <= 0){
          stickySection.style.top = `${document.body.clientHeight - footerPosition.height - editContentAreaPostion.height - stikyPosition.height - lastSectionMargin}px`;
          stickySection.style.width = `${initialWidth}px`;
          stickySection.style.position = 'absolute';
          stickySection.style.left = `${leftColumnPosition.x + leftColumnPosition.width}px`;
        }
        else{
          stickySection.classList.add('pdp-sticky-section');
          stickySection.style.left = `${leftColumnPosition.x + leftColumnPosition.width}px`;
          stickySection.style.width = `${initialWidth}px`;
        }
      }
    }
  }
}
</script>
